import { useTranslation } from "react-i18next";

/**
 * Shown for staff "View portal as patient" sessions, which are read-only server-side —
 * any write the portal offers will fail, so the banner sets that expectation up front.
 */
export const PortalPreviewBanner = () => {
  const { t } = useTranslation("portal");

  return (
    <div className="bg-muted border-b px-4 py-2 text-center text-sm text-muted-foreground">
      <span className="font-medium text-foreground">{t("Read-only preview")}</span>{" "}
      <span>{t("You are viewing this portal as a staff member. Actions that change data are disabled.")}</span>
    </div>
  );
};
